export class DeviceDto {
  id: string = '';
  code: string = '';
  name: string = '';
  remarks: string = '';
}
